import { useMemo } from "react";

export interface TodoistSourceSettingsText {
  projectLabelText: string;
  projectPlaceholderText: string;
  projectHintText: string;
  sectionLabelText: string;
  sectionPlaceholderText: string;
  sectionHintText: string;
  labelLabelText: string;
  labelPlaceholderText: string;
  labelHintText: string;
  loadingProjectsText: string;
  loadingSectionsText: string;
  loadingLabelsText: string;
  loadErrorText: string;
}

export const useTodoistSourceSettingsText = (
  t: (key: string) => string,
): TodoistSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.todoist.${key}`);

    return {
      projectLabelText: tKey("projectLabel"),
      projectPlaceholderText: tKey("projectPlaceholder"),
      projectHintText: tKey("projectHint"),
      sectionLabelText: tKey("sectionLabel"),
      sectionPlaceholderText: tKey("sectionPlaceholder"),
      sectionHintText: tKey("sectionHint"),
      labelLabelText: tKey("labelLabel"),
      labelPlaceholderText: tKey("labelPlaceholder"),
      labelHintText: tKey("labelHint"),
      loadingProjectsText: tKey("loadingProjects"),
      loadingSectionsText: tKey("loadingSections"),
      loadingLabelsText: tKey("loadingLabels"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
